<template>
    <div class="search-apenaf">
        <v-autocomplete
            v-model="select"
            :items="apenafs"
            class="rounded-0"
            label="Par Code Naf"
            outlined
            dense
            hide-selected
            hide-details
            append-icon="mdi-chevron-down"
            item-text="code"
            item-value="code"
            no-data-text="Aucune convention collective ne correspond à votre recherche"
            :multiple="false"
            :clearable="true"
        >
            <template slot="selection" slot-scope="data">
                <div class="suggest selected" v-if="data.item">
                    <typo name="body-10-normal" class="code">
                        {{ dico[data.item.type] ? dico[data.item.type] : data.item.type }}
                    </typo>
                    <typo name="body-14-normal">{{ `${data.item.code} ${data.item.label}` }} </typo>
                </div>
            </template>
            <template slot="item" slot-scope="data">
                <div class="suggest">
                    <typo name="body-10-normal" class="code">
                        {{ dico[data.item.type] ? dico[data.item.type] : data.item.type }}
                    </typo>
                    <typo name="body-14-normal">{{ `${data.item.code} ${data.item.label}` }} </typo>
                </div>
            </template>
        </v-autocomplete>
    </div>
</template>

<script>
export default {
    props: ["value", "apenafs"],
    data() {
        return {
            select: null,
        };
    },
    mounted() {
        this.select = this.value;
    },
    watch: {
        async select(value) {
            this.$emit("input", value);
        },
        value(_value) {
            this.select = _value;
        },
    },
    computed: {
        dico() {
            return this.$privateDico.apenafs;
        },
    },
};
</script>

<style lang="sass" scoped>
.search-apenaf
    display: flex
    align-items: center
    margin: 16px 0
    .suggest
        display: flex
        flex-direction: row
        .code
            background: black
            margin-right: 10px
            padding: 0 5px
            text-align: center
            color: white
            display: inline-block
            text-transform: uppercase
            min-width: 30px
            line-height: 10px
            display: flex
            align-items: center
            align-content: center
            justify-content: center

    .suggest.selected
        white-space: nowrap
        padding-left: 5px

        .typo
            color: $color-secondary

        .code
            background: $color-secondary
            color: white
            padding: 0 3px
            width: auto

        .highlight
            background: transparentize($color-main, 0.8)
</style>
